import { render } from "./index.vue?vue&type=template&id=ae617dd6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ae617dd6&lang=less"
script.render = render

export default script